import { Component, OnInit } from "@angular/core"
import { HelpersService } from "src/app/services/helpers.service"

@Component({
	selector: "app-download-area",
	templateUrl: "./download-area.component.html",
	styleUrls: ["./download-area.component.scss"]
})
export class DownloadAreaComponent implements OnInit {
	files: any
	filesList: any[] = []

	constructor(private helpersService: HelpersService) {}

	ngOnInit(): void {
		this.getItems()
	}

	getItems() {
		this.helpersService.getFiles().subscribe(res => {
			if (res) {
				this.files = res
				this.filesList = res.files
			}
		})
	}

	downloadZip(file) {
		this.helpersService.downloadZip(file.id).subscribe((res: any) => {
			const blob = new Blob([res], {
				type: "application/zip"
			})
			const url = window.URL.createObjectURL(blob)
			window.open(url)
			this.getItems()
		})
	}
}
